/*
 * @Desc: 城市
 * @Author: lc
 * @Date: 2023-09-26 09:28:06
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-27 11:15:48
 */
import request from "@/utils/request";
const guanjia = {
  // 列表
  list (query) {
    return request({
      url: "/guanjia/list",
      method: "get",
      params: query
    });
  },
  // 编辑
  edit (data) {
    return request({
      url: "/guanjia/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail (data) {
    return request({
      url: "/guanjia/detail",
      method: "post",
      data
    });
  },
  // 同步
  sync (data) {
    return request({
      url: "/guanjia/sync",
      method: "post",
      data
    });
  },
  remove (data) {
    return request({
      url: "/guanjia/remove",
      method: "post",
      data
    });
  },
};
export default guanjia;
